import React from 'react'
import { Trans, WithTranslation } from 'react-i18next'
import { FiChevronDown, FiChevronRight, FiList } from 'react-icons/fi'
import {
  Label,
  Link,
  MenuElement,
  MenuList,
} from '../../../../../components/Template/Sidebar'
import { IWithSize } from '../../../../BookingCalendar/Calendar/Calendar'

function Offer({
  isSidebarOpen,
  className,
  size = 1,
}: IWithSize & IOfferProps & WithTranslation) {
  const [isOpen, toggleOpen] = React.useState(false)

  function toggleIsOpen() {
    toggleOpen(!isOpen)
  }

  return (
    <MenuElement
      size={size}
      alignCenter={true}
      primary={true}
      column={true}
      open={isOpen}
      active={isOpen}
    >
      <MenuElement
        size={size}
        as={'div'}
        alignCenter={true}
        open={isOpen}
        onClick={toggleIsOpen}
        className={`${className}-button-expand`}
        nested={true}
      >
        <b>
          <FiList size={16 * size} />
        </b>
        <Label size={size} primary={true} className={`${className}-label`}>
          <Trans i18nKey={'BKO_902_menu_offer'}>Oferta</Trans>
        </Label>
        <b>
          {isSidebarOpen &&
            (isOpen ? (
              <FiChevronDown size={14 * size} />
            ) : (
              <FiChevronRight size={14 * size} />
            ))}
        </b>
      </MenuElement>
      {isSidebarOpen && (
        <MenuList
          size={size}
          nested={true}
          style={{ maxHeight: 'var(--full)' }}
        >
          <Link
            size={size}
            to={'/offer/description'}
            activeClassName={'active'}
            nested={true}
            className={`${className}-item-0-label`}
          >
            <MenuElement
              size={size}
              alignCenter={true}
              className={`${className}-item-0-button`}
            >
              <Trans i18nKey={'BBO_1198_description'}>Opis</Trans>
            </MenuElement>
          </Link>
          {/*<Link*/}
          {/*  size={size}*/}
          {/*  to={'/offer/facilities'}*/}
          {/*  activeClassName={'active'}*/}
          {/*  nested={true}*/}
          {/*  className={`${className}-item-2-label`}*/}
          {/*>*/}
          {/*  <MenuElement*/}
          {/*    size={size}*/}
          {/*    alignCenter={true}*/}
          {/*    className={`${className}-item-1-button`}*/}
          {/*  >*/}
          {/*    <Trans i18nKey={'BBO_3139_facilities'}>Udogodnienia</Trans>*/}
          {/*  </MenuElement>*/}
          {/*</Link>*/}
          <Link
            size={size}
            to={'/offer/regulation'}
            activeClassName={'active'}
            nested={true}
            className={`${className}-item-1-label`}
          >
            <MenuElement
              size={size}
              alignCenter={true}
              className={`${className}-item-1-button`}
            >
              <Trans i18nKey={'terms_and_conditions'}>Regulamin</Trans>
            </MenuElement>
          </Link>
          {/*<Link*/}
          {/*  size={size}*/}
          {/*  to={'/offer/photo'}*/}
          {/*  activeClassName={'active'}*/}
          {/*  nested={true}*/}
          {/*  className={`${className}-item-1-label`}*/}
          {/*>*/}
          {/*  <MenuElement*/}
          {/*    size={size}*/}
          {/*    alignCenter={true}*/}
          {/*    className={`${className}-item-1-button`}*/}
          {/*  >*/}
          {/*    <Trans i18nKey={'BKO_902_menu_photos'}>Zdjęcia</Trans>*/}
          {/*  </MenuElement>*/}
          {/*</Link>*/}
        </MenuList>
      )}
    </MenuElement>
  )
}

export default Offer

export interface IOfferProps {
  isSidebarOpen: boolean
  className?: string
}
